import { Skeleton } from "@/components/ui/skeleton";

const UserFormSkeleton = () => (
  <div className="space-y-8">
    {/* Header Skeleton */}
    <Skeleton className="h-8 w-1/4 bg-muted" />

    {/* Tabs Skeleton */}
    <div className="grid w-full grid-cols-3 gap-2">
      {[1, 2, 3].map((i) => (
        <Skeleton key={i} className="h-10 bg-muted" />
      ))}
    </div>

    {/* Tab Content Skeleton - Shows multiple input fields */}
    <div className="space-y-6 mt-6">
      {/* First section - User Data-like fields */}
      <div className="grid gap-4 grid-cols-2">
        <Skeleton className="h-10 bg-muted" />
        <Skeleton className="h-10 bg-muted" />
        <Skeleton className="h-10 bg-muted col-span-2" />
        <Skeleton className="h-10 bg-muted" />
        <Skeleton className="h-10 bg-muted" />
      </div>

      {/* Second section - Table-like structure */}
      <div className="space-y-4">
        <div className="grid grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-8 bg-muted" />
          ))}
        </div>
        {[1, 2, 3].map((row) => (
          <div key={row} className="grid grid-cols-4 gap-4">
            {[1, 2, 3, 4].map((col) => (
              <Skeleton key={`${row}-${col}`} className="h-10 bg-muted" />
            ))}
          </div>
        ))}
      </div>
    </div>

    {/* Bottom Buttons Skeleton */}
    <div className="flex justify-between pt-8 border-t">
      <Skeleton className="h-10 w-24 bg-muted" />
      <div className="flex space-x-2">
        <Skeleton className="h-10 w-24 bg-muted" />
        <Skeleton className="h-10 w-24 bg-muted" />
        <Skeleton className="h-10 w-24 bg-muted" />
      </div>
    </div>
  </div>
);

export default UserFormSkeleton;
